<template>
  <article class="color-picker">
    <div class="selected-colors" :class="`selected-colors-${colorPickerMode}`">
      <!-- Selected Colors -->
      <ColorPickerColorToChange
        v-for="(color, index) in colorsToChange"
        :key="index + '-selected-color' + componentKey"
        :color="color"
        :openedPicker="openedPicker"
        :isSingleMode="isSingleMode"
        :hideLabels="hideLabels"
        :componentKey="componentKey"
        @openPicker="openPicker"
      />
    </div>
    <!-- Color options -->

    <ColorOptions
      v-show="showPicker"
      :colorKey="openedPicker"
      :mode="colorPickerMode"
      :isPickerOpen="isPickerOpen"
      :selectedColorId="selectedColorId"
      :colorOptions="colorOptions"
      :allowNoneColorOption="allowNoneColorOption"
      :key="componentKey"
      @selectColor="emitSelectColor"
      @close="closePicker"
    />
  </article>
</template>

<script>
import ColorOptions from "@/components/Projects/Project/Colors/ColorOptions.vue";
import ColorPickerColorToChange from "@/components/Projects/Project/Colors/ColorPickerColorToChange.vue";
import { mapState, mapGetters } from "vuex";
export default {
  name: "ColorPicker",
  components: {
    ColorOptions,
    ColorPickerColorToChange,
  },

  props: {
    colorPickerMode: {
      type: String,
      validator: (value) => ["single", "multiple"].includes(value),
    },
    colorsToChange: { type: Array },
    isThreekit: { type: Boolean, default: false },
    hideLabels: { type: Boolean },
    readOnly: { type: Boolean },
    forceReadOnly: { type: Boolean },
    colorsOptionsOverride: { type: Array },
    allowNoneColorOption: { type: Boolean },
    componentKey: { type: String },
  },

  data() {
    return {
      openedPickers: {
        color_1: false,
        color_2: false,
        color_3: false,
      },
    };
  },

  computed: {
    ...mapGetters("project", ["projectColorDependingOnProjectType"]),
    ...mapState("threekit", ["sublimationColors"]),

    isSingleMode() {
      return this.colorPickerMode === "single";
    },
    isMultipleMode() {
      return this.colorPickerMode === "multiple";
    },

    isPickerOpen() {
      return this.isSingleMode && !this.forceReadOnly ? true : !!this.openedPicker && !this.forceReadOnly;
    },

    openedPicker() {
      if (this.isSingleMode) {
        return "color_1";
      } else {
        const keys = Object.keys(this.openedPickers);

        return keys.find((k) => this.openedPickers[k] === true) || null;
      }
    },

    showPicker() {
      return this.isSingleMode && !this.readOnly ? true : this.isPickerOpen;
    },

    selectedColorId() {
      if (this.colorPickerMode === "multiple") {
        return (
          this.openedPicker &&
          this.colorsToChange?.find(
            (color) =>
              color.key
                ?.trim()
                ?.toLowerCase()
                ?.replace(/\s+/g, "_") ==
              this.openedPicker
                ?.trim()
                ?.toLowerCase()
                ?.replace(/\s+/g, "_")
          )?.color?.id
        );
      } else {
        return this.colorsToChange[0]?.color?.id;
      }
    },

    colorOptions() {
      //colorOptions -> we will use this options from the result of mapping the three kit colors
      return this.colorsOptionsOverride?.length
        ? this.colorsOptionsOverride
        : this.projectColorDependingOnProjectType;
    },
  },

  methods: {
    openPicker(key) {
      const normalizedKey = key
        ?.trim()
        ?.toLowerCase()
        ?.replace(/\s+/g, "_"); //we need this to open the color picker
      this.closePicker();

      if (!this.readOnly) this.openedPickers[normalizedKey] = true;
    },
    closePicker() {
      this.openedPickers = {
        color_1: false,
        color_2: false,
        color_3: false,
      };
    },
    emitSelectColor({ color, colorKey }) {
      this.closePicker();
      this.$emit("selectColor", { color, colorKey });
    },
  },
};
</script>

<style lang="scss" scoped>
.selected-colors {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
</style>
